import React from "react";
import styled from "styled-components";
import Layout from "../../components/Layout";
import { Col, Row } from "rsuite";
import { motion } from "framer-motion";
import Icon from "../../components/Icon";
import LazyImage from "../../components/LazyImage";
import { useCongress } from "../../congress/hooks";
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export default function Stands() {
  const { congress, loading } = useCongress()
  return (
    <Layout.Container>
      <Container>
        <Layout.Title>Mapa de stands</Layout.Title>
        <Layout.Loader loading={loading} />
          {congress.StandsMapURL ? (
            <ImageContainer>
              <Image src={congress.StandsMapURL} width="100%" height="100%"/>
            </ImageContainer>
          ) : (
            <Row gutter={32}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <Col md={8}>
                <Icon icon="megaphone" size={16} />
                <span style={{ marginLeft: 4 }}>
                  ¡Pronto publicaremos la información!
                </span>
              </Col>
            </motion.div>
          </Row>
          )}
      </Container>
    </Layout.Container>
  );
}

const Container = styled.div``;

const ImageContainer = styled.div`
  width: 100%;
  padding-bottom: 50%;
  position:relative;
`

const Image = styled(LazyImage)`
  position: absolute;
  border-radius: 10px;
  overflow: hidden;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`
